'use client';

import { TOrganisationIdentityTypeCode } from '@verifime/utils';
import { TFormFieldsAndRulesV3 } from '../../Form';
import useAddEntity from './useAddEntityV2';
import { wizardOrganisationFormFieldsAndRules } from './utils';

type TUseAddEntity = Parameters<typeof useAddEntity>[0];

/**
 * Organisation entity V2 wrapper. Required `AddressView` is forwarded from
 * `props` through to `useAddEntityV2`; callers in customer-portal typically
 * supply `AddressAutocompleteView` from `@verifime/views`.
 */
export default function useAddOrganisationEntityV2<
  OrganisationTypeCode extends TOrganisationIdentityTypeCode,
>({
  organisationTypeCode,
  extraFormFieldsAndRules = {},
  ...props
}: {
  organisationTypeCode: OrganisationTypeCode;
  extraFormFieldsAndRules?: TFormFieldsAndRulesV3;
} & Omit<TUseAddEntity, 'initialFormFieldsAndRules' | 'initialAddresses'>) {
  return useAddEntity({
    initialFormFieldsAndRules: {
      ...wizardOrganisationFormFieldsAndRules[organisationTypeCode].basic,
      ...extraFormFieldsAndRules,
    },
    initialAddresses: wizardOrganisationFormFieldsAndRules[organisationTypeCode].addresses,
    ...props,
  });
}
